export default __webpack_public_path__ + "static/process-feadd397eedd0555c1f8fc81ec695105.svg";